import React from 'react'
import { Mdx } from '@ta-interaktiv/contentbricks'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { browserCheck } from '@ta-interaktiv/browsercheck'
interface Props {
  date: string
  textFile: string
  className?: string
}

export const TimeLineEntry = ({ date, textFile, className }: Props) => (
  <div className='row timeLineEntry'>
    <div className={'two wide column mobile hidden'} />
    <div className={'two wide column date ' + className}>
      <div className='line top' />
      <div className='dateText'>{date}</div>
      <div className='line' />
    </div>
    <div
      className={
        (browserCheck.isMobile ? 'sixteen' : 'ten') +
        ' wide column text ' +
        className
      }
    >
      <Mdx file={require('text/' + textFile)} />
    </div>
  </div>
)
